export function getDeployment() {
    const environment = process.env.REACT_APP_ENVIRONMENT || 'canary';
    if (environment === 'production') {
        return window.location.hostname.split('.')[0];
    }

    return 'testing';
}
